var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 70,
    viewBox: "0 0 51 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 2.5H36.125C30.5444 2.5 25.1924 4.21205 21.2463 7.25951C17.3002 10.307 15.0833 14.4402 15.0833 18.75V28.5H2.45834V41.5H15.0833V67.5H31.9167V41.5H44.5417L48.75 28.5H31.9167V18.75C31.9167 17.888 32.3601 17.0614 33.1493 16.4519C33.9385 15.8424 35.0089 15.5 36.125 15.5H48.75V2.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsFacebook);
export default __webpack_public_path__ + "static/media/ms_facebook.6a811ac3c4bd9c33dbbfdd2c149d126f.svg";
export { ForwardRef as ReactComponent };